module.exports = __webpack_public_path__ + "assets/img/map-place.e28a370e.png";